exports.list = {
    path: '/laporan_hutang_lain',
    name: 'laporan_hutang_lain', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_hutang_lain/List.vue"),
  }
  